import React, { Component, useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import sectiondata from '../../data/sections.json';
import { searchProperty } from "../../request/apiRquest";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Spin } from "antd";
import PropertyCallingButton from "../../utils/PropertyCardCall";
import PropertyWhatsAppButton from "../../utils/PropertyCardWhatsApp";
import FormatePrice from "../../utils/FormatePrice";
import { Button, Modal } from "antd";
import GetInTouch from "../../utils/getInTouch";
import PropertyDetailsList from "../../JsonData/property-details.json"
import { slugify } from "../../utils/slugify";


const PropertyByDubai = () => {

    const carouselSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false
    };


    const [propertices, setPropertices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectCities, setSelectedStates] = useState('24');
    const [open, setOpen] = useState(false);
    const showModal = () => setOpen(true);
    const handleCancel = () => setOpen(false);

    let propertydata = PropertyDetailsList.PropertyDetailsList

    const getpropertylist = async () => {
        setLoading(true);
        try {
            
            const filterProperties = propertydata.filter((item) => 
             item.city?.toLowerCase() === "dubai"
            )

            setPropertices(filterProperties);
        } catch (error) {
            console.error("Error properties is not show ", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getpropertylist();
    }, [])

    //  console.log(propertices.length, "proppp");

    let publicUrl = process.env.PUBLIC_URL + '/'
    let imagealt = 'image'
    let data = sectiondata.propertybydubai


    return <div className="properties-area pd-top-92">
        <div className="container">
            <div className="section-title">
                <h2 className="title">{data.sectiontitle}</h2>
                  <Link className="btn-view-all" to="/properties">View All</Link>
            </div>
            {/* <div className="row">

                {data.items.map((item, i) =>
                    <div key={i} className="col-lg-3 col-sm-6 ">
                        <div className="single-feature">
                            <div className="thumb">
                                <img src={publicUrl + item.image} alt="img" />
                            </div>
                            <div className="details">
                                <a href="#" className="feature-logo">
                                    <img src={publicUrl + item.icon} alt={imagealt} />
                                </a>
                                <p className="author"><i className="fa fa-user" /> {item.authorname}</p>
                                <h6 className="title readeal-top"><Link to={item.url}>{item.title}</Link></h6>
                                <h6 className="price">{item.newerprice}</h6><del>{item.olderprice}</del>
                                <ul className="info-list">
                                    {item.features.map((features, i) =>
                                        <li key={i} ><i className={features.icon} /> {features.title}</li>
                                    )}
                                    <li><img src={publicUrl + "/assets/img/icons/7.png"} alt={imagealt} /> {item.area}  </li>
                                </ul>
                                <ul className="contact-list">
                                    <li><a className="phone" href="#"><i className="fa fa-phone" /></a></li>
                                    <li><a className="message" href="#"><img src={publicUrl + "/assets/img/icons/8.png"} alt="img" /></a></li>
                                    <li className="readeal-top"><Link className="btn btn-yellow" to={item.url} >View Details</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )}

            </div> */}

            {loading ? (
                //<div className="text-center">Loading properties...</div>
                <div className="text-center py-5">
                    <Spin className="custom-orange-spin" size="large" tip="Loading properties..." />
                </div>
            ) : (
                <>
                    <div className="row">
                        {propertices?.length > 0 ? (
                            propertices.slice(0, 9)?.map((item, index) => {
                                const images = item?.images || [];

                                return (
                                    <div key={index} className="col-xl-4 col-sm-6">
                                        <div className="single-feature">
                                            {/* <div className="thumb">
                                                {images.length > 1 ? (
                                                    <Slider {...carouselSettings}>
                                                        {images?.map((img, index) => (
                                                            <div key={index}>
                                                                <img
                                                                    src={img?.src}
                                                                    alt={`Property ${index}`}
                                                                    className="img-fluid property-image"
                                                                    style={{
                                                                        height: '250px',
                                                                        width: '100%',
                                                                        objectFit: 'cover',
                                                                        imageRendering: 'auto',
                                                                        display: 'block',
                                                                        backfaceVisibility: 'hidden',
                                                                        transform: 'translateZ(0)', // Helps with sharp rendering on some devices
                                                                        WebkitBackfaceVisibility: 'hidden'
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                ) : (
                                                    <img
                                                        src={images[0]?.src}
                                                        alt="No image available"
                                                        className="img-fluid"
                                                        style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                                                    />
                                                )}
                                            </div> */}

                                            <div className="thumb position-relative">
                                                <Button
                                                    className="position-absolute"
                                                    style={{
                                                        top: '10px',
                                                        right: '10px',
                                                        zIndex: 2,
                                                        padding: '6px 12px',
                                                        fontSize: '14px',
                                                        borderRadius: '5px',
                                                        width: "150px",
                                                        color: "#FDA94F"
                                                    }}
                                                    onClick={showModal}
                                                >
                                                    Enquire Now
                                                </Button>
                                                <img
                                                    src={images[0]?.src}
                                                    alt="Property"
                                                    className="img-fluid property-image"
                                                    style={{
                                                        height: '250px',
                                                        width: '100%',
                                                        objectFit: 'cover',
                                                        imageRendering: 'auto',
                                                        display: 'block',
                                                        backfaceVisibility: 'hidden',
                                                        transform: 'translateZ(0)',
                                                        WebkitBackfaceVisibility: 'hidden'
                                                    }}
                                                />
                                            </div>


                                            <div className="details">
                                                {/* {data.items.map((item, i) =>
                                                <a href="#" className="feature-logo">
                                                    <img src={publicUrl + item.icon} alt={imagealt} />
                                                </a>
                                            )} */}
                                                {/* <p className="author" style={{ gap: "15px" }}><i className="fa fa-user" />{item.name || 'Unknown'}</p> */}
                                                <h6 className="price">
                                                    {FormatePrice(item.price)}  AED
                                                </h6>
                                                <h6 className="title readeal-top"><Link >{item.PropertyName}</Link></h6>
                                                <h6 className="title readeal-top" style={{ fontSize: "12px" }}> <i class="fa fa-home" style={{ color: "orange", fontSize: "15px" }}></i>  {item.building_type}</h6>
                                                <p className="location"><i className="fa fa-map-marker" style={{ marginRight: '5px', color: 'red', color: "orange " }} />
                                                    {item.locality}</p>

                                                <ul className="info-list">
                                                    <li key={index}><i className="fa fa-bed" /> {item.bhk_type}</li>
                                                    {/* <li><i className="fa fa-bath" /> {item.number_bathroom}</li> */}
                                                    <li><img src={"/assets/img/icons/7.png"} alt={imagealt} /> {item.builtup_area}  sq ft</li>

                                                </ul>
                                                <ul className="contact-list">
                                                    <li className="readeal-top"><Link className="btn btn-yellow"
                                                        //  to={item.url}
                                                        to={`/property-details/${slugify(item.PropertyName)}`}
                                                    >View Details</Link></li>

                                                    <li>
                                                        <PropertyCallingButton />
                                                    </li>

                                                    <li>
                                                        <PropertyWhatsAppButton />
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                        <Modal
                                            title=""
                                            open={open}
                                            onCancel={handleCancel}
                                            footer={null}
                                            maskStyle={{ backgroundColor: 'transparent' }}  //  background black nahi hoga
                                            maskClosable={false}  //  background pe click karne se close bhi nahi hoga
                                        >
                                            <GetInTouch onClose={handleCancel} />
                                        </Modal>
                                    </div>
                                )
                            })
                        ) : (
                            <div className="col-12 text-center">
                                <p>No properties available in Dubai at the moment.</p>
                            </div>
                        )}
                    </div>
                    {/* Pagination */}
                    {/* {propertylist.length < propertylist.length && (
                              <div className="property-filter-menu portfolio-filter text-center mb-3">
                                <button
                                  className="btn btn-yellow"
                                  onClick={loadMore}
                                  disabled={loading}
                                >
                                  {loading ? 'Loading...' : 'Load More'}
                                </button>
                              </div>
                            )} */}
                </>
            )}
        </div>
    </div>




}

export default PropertyByDubai